<template>
  <ItemForm mode="add" />
</template>

<script>
import ItemForm from "@/components/product/ItemForm.vue";

export default {
  name: "addproduct",
  components: { ItemForm },
};
</script>
